//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import resItem from './item.vue'
import subLength from '@/common/library/subLength.js'
import uniRate from "@/components/uni-rate/uni-rate.vue"
import collect from '@/components/collect/index.vue'
import moment from 'dayjs'
import moreContent from '@/components/more-content/index.vue'
import commentList from '@/components/commentList/index.vue'
import uniIcons from "@/components/uni-icon/uni-icon.vue"
export default {
  data() {
    return {
      indicatorDots: true,
      indicatorColor: 'rgba(255, 255, 255, .9)',
      autoplay: true,
      interval: 2000,
      duration: 500,
      imgList: [],
      current: 1, //当前所在滑块
      currentLength: 0, //图片总数
      id: '',
      detail: {
        bodyIntroduce: ''
      },
      setMeal: [],
      cashCoupon: [],
      tagList: [],
      foodList: [],
      // 评论相关
      commentObj: {
        total: 0,
        starLevel: 5
      },
      collect: {
        collectionType: '30',
        productGroupType: '2003',
        collectionId: ''
      },
    }
  },
  components: { uniIcons, uniRate, resItem, moreContent, commentList, collect },
  computed: {
    rank() {
      let a = 'AAAAA'
      return this.detail.starType === 1 ? '其他' : a.substr(0, this.detail.starType)
    },
    address() {
      return this.detail.detailAddress ? subLength(this.detail.detailAddress, 38) : ''
    }
  },
  onLoad(event) {
    this.collect.collectionId = this.id = event.id
    this.queryData()
  },
  onShow() {
  },
  methods: {
    //顶部轮播图当前图片页数
    changeImg(event) {
      this.current = event.detail.current + 1
    },
    queryData() {
      let _this = this
      this.$ajax({
        method: 'POST',
        url: '/weChat/foodBody/queryByBodyId',
        data: {
          id: this.id
        },
      }).then((res) => {
        _this.detail = res.data
        _this.foodList = res.data.recommendFoodIds.split(',')
        _this.detail.address = res.data.provinceName + '  ' + res.data.cityName + '  ' + res.data.districtName + ' 详细地址:' + res.data.detailAddress
        _this.imgList = res.data.images.split(',')
        _this.tagList = res.data.labelCodeVos ? res.data.labelCodeVos : []
        _this.currentLength = _this.imgList.length



        res.data.list.map((t) => {
          t.validStartDate = t.validStartDate ? moment(t.validStartDate).format('M月DD日') : ''
          t.validEndDate = t.validEndDate ? moment(t.validEndDate).format('M月DD日') : ''
          t.effectTime = t.effectTime ? moment(t.effectTime).format('M月DD日') : ''
          t.effectEndTime = t.effectEndTime ? moment(t.effectEndTime).format('M月DD日') : ''
          if (t.foodType === 2) {
            _this.setMeal.push(t)
          } else if (t.foodType === 1) {
            _this.cashCoupon.push(t)
          }
        })
      })
    },
    tel(phone) {
      uni.makePhoneCall({
        phoneNumber: phone //仅为示例
      })
    },
    jump() {
      uni.navigateTo({
        url: '/pages/common/images?image=' + this.imgList
      })
    },
    showPosition() {
      if (this.detail.latitude && this.detail.longitude) {















      }
    },
    toCommentList() {
      uni.navigateTo({
        url: `/pages/comment/list?bodyId=${this.id}&productId=`
      })
    },
    updateComments(data) {
      this.commentObj.total = data.count
      this.commentObj.starLevel = parseFloat(data.dataObj || 0)
    }
  }
}
